import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { SessionService } from '@core/services/session.service';
import { CardComponent } from '@core/components/card/card.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { DISCORD_LINK } from '@core/constants/discord.constants';

@Component({
  selector: 'app-join-discord-widget',
  imports: [CardComponent, SvgIconComponent],
  templateUrl: './join-discord-widget.component.html',
  styleUrl: './join-discord-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class JoinDiscordWidgetComponent {
  public readonly DISCORD_LINK = DISCORD_LINK;

  sessionService = inject(SessionService);
  isDiscordSuccess = computed(() => {
    return (
      this.sessionService.discord().linked &&
      this.sessionService.discord().joined
    );
  });
}
